<template>
  <div class="top2">
    <div class="rn-back-top2" :class="[visible ? 'd-inline' : 'd-none']">
      <!-- <Icon name="bi bi-headset" size="27" /> -->
      <!-- <i class="bi bi-headset"></i> -->
      <img src="../../../assets/images/header_nav/linkUs.png" alt="">
    </div>
    <div class="blueUS">
      <div class="Hotline">
        <div class="left">
          <div class="t1"><img src="../../../assets/images/header_nav/phone-icon-block.png" alt="" />咨询热线</div>
          <div>周一 至 周五<br />09:00-18:00</div>
        </div>
        <div class="right">186 0092 4570
          <!-- <br />186 0092 4570 -->
        </div>
      </div>
      <div class="scanCode">
        <div class="left">
          <div class="t1"><img src="../../../assets/images/header_nav/code-icon-block.png" alt="" />扫码咨询</div>
          <div>专业扫码获取<br />专业咨询服务</div>
        </div>
        <div class="right code"><img src="../../../assets/images/header_nav/code-code.png" alt="" /></div>
      </div>
      <div class="online">
        <div class="left t1"><img src="../../../assets/images/header_nav/online-icon-block.png" alt="" />在线咨询</div>
        <div class="right online-btn" @click="toCall">咨询</div>
      </div>
    </div>
    <div class="img-block">
      <img class="blueUS-img" src="../../../assets/images/header_nav/Fixed.png" alt="">
    </div>
  </div>
</template>
<style lang="scss">
.top2{
  position: fixed;
  z-index: 999;
  .blueUS{
    display:none;
  }

}
.top2:hover{
  .blueUS{
    display: block;
    position: fixed;
    bottom: 60px;
    right: 100px;
    z-index: 100;
    overflow: hidden;
    width: 300px;
    height: 300px;
    background-color:#fff;
    font-size: 13px;
    padding:0 20px;
    border-radius: 10px;
    .Hotline,.scanCode,.online{
        display: flex;
        justify-content: space-between;
        padding: 20px 0;
        padding-left: 26px;
        border-bottom: 1px solid #fff;
        .t1{
            font-size: 16px;
            margin-left: -26px;
            img{
                margin-right: 10px;
            }
        }
    }
    .online-btn{
        border-radius: 3px;
        background-color: #005bab;
        width: 80px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #fff;
        border-radius: 20px;
        cursor: pointer;
    }
  }
  .img-block{
    
    position: fixed;
    bottom: 90px;
    right: 30px;
    z-index: 20;
    width: 80px;
    .blueUS-img{
    }
  }
}

</style>
<script>
import Icon from "../../icon/Icon"
export default {
  name: "ScrollTop2",
  components: { Icon },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    toggleVisible() {
      const scrolled = document.documentElement.scrollTop
      if (scrolled > 300) {
        this.visible = true
      } else if (scrolled <= 300) {
        this.visible = false
      }
    },
    toCall(){
      this.$router.push({
        path: '/call-us'
      })
    }
  },
  created() {
    window.addEventListener("scroll", this.toggleVisible)
  },
  mounted() {
    this.toggleVisible()
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.toggleVisible)
  },
}
</script>
